"use client"

// console.log("📦 [Providers Module] providers.tsx loaded");

import createApolloClient, { resetApolloClient } from "@/lib/setupApollo";
import { ApolloProvider } from "@apollo/client";
import React, { useMemo, useEffect, useState } from "react";
import { MantineProvider } from '@mantine/core';

interface ProvidersProps {
    children: React.ReactNode;
    initialHost?: string;
}

export const Providers = ({ children, initialHost }: ProvidersProps) => {
    // console.log("🚀 [Providers] Component initializing with initialHost:", initialHost);
    const [hostname, setHostname] = useState<string>(initialHost || "");

    useEffect(() => {
        // Set hostname on client side and reset client if it changed
        if (typeof window !== "undefined") {
            const currentHostname = window.location.hostname;
            // console.log("🌐 [Providers] Client-side hostname detected:", currentHostname);
            
            if (currentHostname !== hostname) {
                // console.log("🔄 [Providers] Hostname changed, resetting Apollo client");
                resetApolloClient();
                setHostname(currentHostname);
            }
        }
    }, [hostname]);

    // Create client based on hostname
    const client = useMemo(() => {
        // console.log("🔄 [Providers] Creating Apollo client for hostname:", hostname || "default");
        return createApolloClient();
    }, [hostname]);

    return (
        <MantineProvider>
            <ApolloProvider client={client}>
                {children}
            </ApolloProvider>
        </MantineProvider>
    );
};
